export default function(element, offset) {
  var scrollY =
    element.getBoundingClientRect().top +
    $(window).scrollTop() +
    (parseInt(offset, 10) || 0);
  window.scrollTo(window.scrollX, scrollY);
}
